export default __webpack_public_path__ + "static/media/debate_15.3061332f.JPG";